import React from "react"
import Layout from "../components/layout"
import Banner from '../components/banner'
import HowToGuide from '../components/how-to-guides'
import ProfilesCards from '../components/profiles-cards'
import RelatedServices from '../components/related-services'
import PopularServices from '../components/popular-services'
import PopularArticles from '../components/popular-articles'
import QuoteStepsModal from '../components/quote-steps-modal'
import NearbyServices from '../components/nears-services'
import AnywereServices from '../components/anys-services'
import IconsKeywords from '../components/icons-keywords'
import ZipFinder from '../components/zip-finder'
import EmptyProfile from '../components/empty-profiles'
import KppTips from "../components/kpptips"

const KPP = ({ pageContext }) => 
{       
    const title = pageContext.title
    const modal_project_types = pageContext.modal_project_types
    const profiles = pageContext.profiles.length > 0 ? pageContext.profiles[0] : []     
    const env = pageContext.env
    const articles = pageContext.articles 
    const code = pageContext.code
    const codes = pageContext.codes.length > 0 ? pageContext.codes : []  
    const populars = pageContext.populars.length > 0 ? pageContext.populars : []
    const anys = pageContext.anyweres
    const related = pageContext.related
    const nears = pageContext.nears
    const icons = pageContext.icons    
    const keygroup_name = pageContext.page === 'kpp' ? undefined : pageContext.keyword_group.name
    const bread = pageContext.page === 'kpp' ? undefined : (pageContext.bread ? pageContext.bread.url : '#')
    const main_menu = pageContext.main_menu
    const footer_menu = pageContext.footer_menu  
    const tip = pageContext.tips.length > 0 ? pageContext.tips[0] : {} 

    const text = env.site === 'dumpster' ? "Find the top dumpster rental companies serving your hometown": "Find the right contractor to demolish and remove anything"
    const placeholder = "Enter Zip Code"
    const button = env.site === 'dumpster' ? "Find Pros" : "Get Started"
    const bottomtext = env.site === 'dumpster' ? "America's #1 Source for Dumpsters and Junk Removal" : "America's #1 Source for Local Demolition Experts"
    const finderopenmodal = env.site === 'dumpster' ? false : true
    const classes = env.site === 'dumpster' ? '' : 'smallest'
    const empty = profiles.length > 0  ? false : true

    const place =
    {
        name:pageContext.place.name,
        ht: pageContext.place.ht,
        state:
        {
            name:pageContext.place.state.name,
            av:pageContext.place.state.av,
            slug:pageContext.place.state.slug
        }
    }    

    const top = () =>
    {
        if(env.site !== 'dumpster') 
            return(   
                <ZipFinder
                    id= 'home-zip-code'
                    code = {code}
                    title = {title}
                    text = {text}
                    placeholder = {placeholder}
                    button = {button}
                    bottomtext = {bottomtext}
                    codes = {codes}
                    env = {env} 
                    finderopenmodal = {finderopenmodal}
                    class = {classes}
                    /> 
            )

        return(   
            <Banner 
                title={title} 
                code={code}
                bottomtext="America's #1 Source for Dumpsters and Junk Removal"
                place={place}
                url = {pageContext.url}
                codes = {codes}
                keygroup_name = {keygroup_name}
                bread = {bread}
                /> 
        )
    }

    const bootom = () =>
    {
        if(env.site !== 'dumpster')
            return(
                <div className="bg-grey pt-5 pb-5">
                    <div className="container ">
                        <div className="row">                           
                            {nears.length > 0 &&  <div className="col-md-4"><NearbyServices env={env} services={nears} place={place} code={code} codes={codes} /></div>}
                            {populars.length > 0 &&  <div className="col-md-4"><PopularServices env={env} services={populars} place={place} code={code} /></div>}
                            {anys.length > 0 && <div className="col-md-4"><AnywereServices env={env} services={anys} place={place} code={code} /></div> }
                        </div>
                    </div>     
                </div>
            )

        return(
            <div className="bg-grey pt-5 pb-5">
                <div className="container ">
                    <div className="row">
                        <div className="col-md-4"><HowToGuide env={env}/></div> 
                        {related.length > 0 && <div className="col-md-4"><RelatedServices env={env} services={related} place={place} code={code} /></div>}
                        {populars.length > 0 && <div className="col-md-4"><PopularServices env={env} services={populars} place={place} code={code} /></div>}                                                  
                    </div>    
                    <div className="row"><PopularArticles articles={articles} /></div>
                </div>     
            </div>
        )
    }

    const geticons = () =>
    {       
        if(env.site !== 'demolition') return(<></>) 

        return(<IconsKeywords 
            icons={icons} 
            code={code} 
            codes={codes}
            keygroup_name = {keygroup_name}
            bread = {bread}   
            place={place}
            url = {pageContext.url}  
            />)
    }

    const seo_desc = pageContext.seo_desc
    const seo = 
    {
        url: pageContext.url,
        env: env,
        place: place,
        code: code,
        page: pageContext.page,
        seo_desc: seo_desc
    }

    return (
        <Layout seo={seo} footercolor={'white'} env={env} code={code} main_menu={main_menu} footer_menu={footer_menu}>                

                <QuoteStepsModal env={env} code={code} modal_project_types={modal_project_types} />

                {top()}               

                <div className="div d-none"><strong>{pageContext.pros}</strong></div>

                {geticons()}

                {empty && <EmptyProfile env={env} code={code}/>}

                {!empty && <ProfilesCards profiles={profiles} env={env} code={code} place={place}/>}

                {bootom()}     

                <div className="bg-grey container-fuild">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">                            
                                <KppTips tip={tip} codes={codes} code={code} place={place} />
                            </div>
                        </div>
                    </div>
                </div>

        </Layout>
    )
}

export default KPP